@if (isLoading) {
  <korviu-loader></korviu-loader>
}
<div class="pb-6 md:pb-8 flex flex-col justify-center items-center">
  <h4 class="heading-small bold pb-4 md:pb-6">{{ 'faq.contact-help-header' | translate }}</h4>
  @if (faq) {
    <p class="text-base md:text-lg font-light px-3 md:px-0 text-center">
      {{ 'faq.contact-help-subheader' | translate }}
    </p>
  }
  @if (balance) {
    <p class="paragraph-medium font-light text-center">{{ 'faq.contactHelpReward' | translate }}</p>
  }
</div>
<form [formGroup]="contactUsForm">
  <div class="pb-4 flex gap-4">
    <korviu-input
      class="w-full"
      type="text"
      label="{{ 'auth.signup.firstName' | translate }}"
      [control]="firstNameControl"
    ></korviu-input>
    <korviu-input
      type="text"
      class="w-full"
      label="{{ 'auth.signup.lastName' | translate }}"
      [control]="lastNameControl"
    ></korviu-input>
  </div>
  <div class="pb-4">
    <korviu-input
      label="{{ 'common.phone' | translate }}"
      type="phone"
      maxLength="14"
      class="phone-number-field"
      [control]="phoneNumberControl"
      [phoneNumberPrefixControl]="phoneNumberCodeControl"
      [errorMessages]="[
        { errorCode: 'pattern', localizedMessage: 'common.validations.invalidPhoneNumber' },
        { errorCode: 'minlength', localizedMessage: 'common.validations.invalidPhoneNumber' }
      ]"
    >
    </korviu-input>
  </div>
  <div class="pb-4">
    <korviu-input
      type="text"
      label="{{ 'common.email' | translate }}"
      [control]="emailControl"
      [errorMessages]="[
        { errorCode: 'emailInUse', localizedMessage: 'common.validations.emailInUse' },
        { errorCode: 'domainNotAllowed', localizedMessage: 'common.validations.domainNotAllowed' }
      ]"
    ></korviu-input>
  </div>
  <div class="pb-4">
    <korviu-textarea
      placeholder="{{ 'common.describeConcern' | translate }}"
      [control]="questionControl"
      #questionField
    ></korviu-textarea>
  </div>
  <div class="flex flex-col justify-center items-center">
    <div class="flex justify-center items-center mb-2 w-full">
      <nz-upload
        [nzBeforeUpload]="beforeUpload"
        [nzFileList]="fileList"
        [nzShowUploadList]="false"
        [nzRemove]="removeFile"
        [nzAccept]="'image/png, image/jpeg'"
        class="w-full"
      >
        <korviu-button color="ghost" class="w-full flex justify-center items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none" class="pr-2">
            <path
              d="M4.79354 10.4968H9.49194C9.90615 10.4968 10.2419 10.8326 10.2419 11.2468C10.2419 11.6265 9.95978 11.9403 9.59371 11.9899L9.49194 11.9968H4.79354C4.12186 11.9968 3.59079 12.4464 3.52702 12.9981L3.5206 13.1097L3.5 17.8862C3.5 18.447 3.98909 18.9316 4.64056 18.99L4.77293 18.9959H19.2271C19.8987 18.9959 20.4298 18.5463 20.4936 17.9946L20.5 17.883L20.5206 13.1065C20.5206 12.5457 20.0315 12.061 19.38 12.0027L19.2477 11.9968H14.5528C14.1386 11.9968 13.8028 11.661 13.8028 11.2468C13.8028 10.8671 14.0849 10.5533 14.451 10.5036L14.5528 10.4968H19.2477C20.7073 10.4968 21.9237 11.5634 22.0151 12.9427L22.0206 13.1097L22 17.8862C22 19.2863 20.8398 20.4067 19.401 20.4909L19.2271 20.4959H4.77293C3.3133 20.4959 2.09692 19.4293 2.00551 18.05L2 17.883L2.0206 13.1065C2.0206 11.7064 3.18084 10.586 4.61961 10.5018L4.79354 10.4968ZM12.4462 3.64705L12.5303 3.71967L16.4554 7.64473C16.7483 7.93763 16.7483 8.4125 16.4554 8.70539C16.1891 8.97166 15.7725 8.99587 15.4788 8.77801L15.3947 8.70539L12.7383 6.04581L12.7397 15.7539C12.7397 16.1681 12.4039 16.5039 11.9897 16.5039C11.5755 16.5039 11.2397 16.1681 11.2397 15.7539L11.2409 6.069L8.60526 8.70539C8.33899 8.97166 7.92233 8.99587 7.62872 8.77801L7.5446 8.70539C7.27833 8.43913 7.25413 8.02246 7.47198 7.72885L7.5446 7.64473L11.4697 3.71967C11.7359 3.4534 12.1526 3.4292 12.4462 3.64705Z"
              fill="#007DCB"
            />
          </svg>
          {{ 'faq.uploadFile' | translate }}
        </korviu-button>
      </nz-upload>
    </div>
    <div class="flex flex-col w-full file-preview-container">
      @for (file of fileList; track file) {
        <div class="py-2 px-4 rounded-lg mb-2 relative flex items-center gap-4 file-preview">
          @if (file?.type?.startsWith('image/')) {
            <img [src]="file?.thumbUrl" alt="Image Preview" class="w-[26px] h-[32px] object-cover rounded-sm" />
          }
          @if (file?.type === 'application/pdf') {
            <i nz-icon nzType="file-pdf" class="pdf-icon"></i>
          }
          <div class="flex flex-col justify-center flex-grow">
            <span class="paragraph-small-text outfit">{{ file?.name }}</span>
            <span class="paragraph-small oufit file-size">{{ file?.size | fileSize }}</span>
          </div>
          <button class="remove-button" (click)="removeFile(file)">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
              <path
                d="M2.93006 3.53846L2.97848 3.48238C3.15599 3.30487 3.43376 3.28874 3.6295 3.43397L3.68559 3.48238L7.9987 7.79527L12.3118 3.48238C12.5071 3.28712 12.8236 3.28712 13.0189 3.48238C13.2142 3.67764 13.2142 3.99423 13.0189 4.18949L8.70603 8.5026L13.0189 12.8157C13.1964 12.9932 13.2126 13.271 13.0673 13.4667L13.0189 13.5228C12.8414 13.7003 12.5636 13.7165 12.3679 13.5712L12.3118 13.5228L7.9987 9.20994L3.68559 13.5228C3.49033 13.7181 3.17374 13.7181 2.97848 13.5228C2.78322 13.3275 2.78322 13.011 2.97848 12.8157L7.29137 8.5026L2.97848 4.18949C2.80096 4.01198 2.78483 3.7342 2.93006 3.53846Z"
                fill="#393E44"
              />
            </svg>
          </button>
        </div>
      }
    </div>
    <div class="flex flex-col w-full">
      <span class="paragraph-small-card font-normal text-center mt-2 outfit upload-message">
        {{ 'faq.uploadFileSize' | translate }}
      </span>
      <span class="paragraph-small-card font-normal text-center outfit upload-message">
        {{ 'faq.uploadFileMessage' | translate }}
      </span>
    </div>
  </div>
</form>
<span class="text-base md:text-lg font-light block text-center pt-8 md:pt-10 md:pb-2">
  {{ 'faq.contact-support' | translate }}
  <a href="mailto:info@unigana.com" class="bold">{{ 'faq.contact-support@' | translate }}</a></span
>
<div *nzModalFooter class="flex gap-4">
  <korviu-button color="ghost" (click)="onCancelClick()" class="w-full">{{
    'common.cancel' | translate
  }}</korviu-button>
  <korviu-button [disabled]="contactUsForm.invalid" color="tertiary" (click)="onSubmitContactForm()" class="w-full">{{
    'common.send' | translate
  }}</korviu-button>
</div>
